import { DefaultSla } from './service-level';
/**
 * Routing priority order, highest priority first. Used to pick the highest-priority address for a
 * client. This is NOT the UI display order (see {@link PLATFORM_SLA_DISPLAY_ORDER}).
 *
 * Do not change this order without a direct change request — routing decisions depend on it.
 */
export const PLATFORM_SLA_PRIORITY_LIST = [
    DefaultSla.Signature,
    DefaultSla.Proactive,
    DefaultSla.Priority,
    DefaultSla.SecurityOnly,
    DefaultSla.EssentialsPlus,
    DefaultSla.Essentials,
];
/**
 * UI display order for platform SLAs. This is NOT the routing priority order (see
 * {@link PLATFORM_SLA_PRIORITY_LIST}) — note `security_only` sorts first here, last there.
 */
export const PLATFORM_SLA_DISPLAY_ORDER = [
    DefaultSla.SecurityOnly,
    DefaultSla.Essentials,
    DefaultSla.EssentialsPlus,
    DefaultSla.Priority,
    DefaultSla.Proactive,
    DefaultSla.Signature,
];
export function platformSlaSortIndex(platformSlaId) {
    if (!platformSlaId)
        return PLATFORM_SLA_DISPLAY_ORDER.length;
    const i = PLATFORM_SLA_DISPLAY_ORDER.indexOf(platformSlaId);
    return i === -1 ? PLATFORM_SLA_DISPLAY_ORDER.length : i;
}
export function sortByPlatformSlaId(items) {
    return [...items].sort((a, b) => platformSlaSortIndex(a.platformSlaId) - platformSlaSortIndex(b.platformSlaId));
}
